import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import '@/App.css';
import HomePage from '@/pages/HomePage';
import AdminDashboard from '@/pages/AdminDashboard';
import AdminLogin from '@/pages/AdminLogin';
import AdminAuthors from '@/pages/AdminAuthors';
import AuthorRegister from '@/pages/AuthorRegister';
import AuthorLogin from '@/pages/AuthorLogin';
import AuthorDashboard from '@/pages/AuthorDashboard';
import AuthorProfileEdit from '@/pages/AuthorProfileEdit';
import ForgotPassword from '@/pages/ForgotPassword';
import ResetPassword from '@/pages/ResetPassword';
import PublicExplorer from '@/pages/PublicExplorer';
import ArticleDetail from '@/pages/ArticleDetail';
import TopImpact from '@/pages/TopImpact';
import MostRigorous from '@/pages/MostRigorous';
import ResearchInsightPage from '@/pages/ResearchInsightPage';
import AboutPage from '@/pages/AboutPage';
import ContactPage from '@/pages/ContactPage';
import CompareArticles from '@/pages/CompareArticles';
import GraphicalAbstractPage from '@/pages/GraphicalAbstractPage';
import ThesisProjects from '@/pages/ThesisProjects';
import ThesisWorkspace from '@/pages/ThesisWorkspace';
import ThesisLogin from '@/pages/ThesisLogin';
import { Toaster } from '@/components/ui/sonner';
import { ThemeProvider } from '@/components/ThemeProvider';

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
      <div className="App min-h-screen bg-background text-foreground">
        <BrowserRouter>
          <Routes>
          <Route path="/" element={<HomePage />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/authors" element={<AdminAuthors />} />
          
          {/* Author Routes */}
          <Route path="/author/register" element={<AuthorRegister />} />
          <Route path="/author/login" element={<AuthorLogin />} />
          <Route path="/author/dashboard" element={<AuthorDashboard />} />
          <Route path="/author/profile/edit" element={<AuthorProfileEdit />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          
          {/* Public Routes */}
          <Route path="/explorer" element={<PublicExplorer />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/top-impact" element={<TopImpact />} />
          <Route path="/most-rigorous" element={<MostRigorous />} />
          <Route path="/compare" element={<CompareArticles />} />
          <Route path="/graphical-abstract/:articleId" element={<GraphicalAbstractPage />} />
          <Route path="/article/:articleId" element={<ArticleDetail />} />
          <Route path="/research-insight/:articleId" element={<ResearchInsightPage />} />
          <Route path="/insight/:articleId" element={<ResearchInsightPage />} />

          {/* ThesisRAG (RAG-based doctoral thesis writing) — standalone branded module */}
          <Route path="/thesis/login" element={<ThesisLogin />} />
          <Route path="/thesis" element={<ThesisProjects />} />
          <Route path="/thesis/:projectId" element={<ThesisWorkspace />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  </ThemeProvider>
  </HelmetProvider>
  );
}

export default App;
